import request from '@/utils/request';
import axios from 'axios';
import config from '@/config'
// 登录
export function login(data) {
  return request({
    url: '/api/console/login',
    method: 'post',
    params: data
  });
}

// 注册
export function register(data) {
  return request({
    url: '/api/console/register/v2',
    method: 'post',
    params: data
  });
}

// 获取注册验证码
export function getAuthCode(data) {
  return request({
    url: '/api/console/codes/register',
    method: 'post',
    params: data
  });
}

// 获取找回密码验证码
export function getResetAuthCode(data) {
  return request({
    url: '/api/console/codes/retrieve',
    method: 'post',
    params: data
  });
}

// 找回密码
export function resetPass(data) {
  return request({
    url: '/api/console/retrieve/pwd',
    method: 'post',
    params: data
  });
}

// 开发者信息
export function getDevelopInfo() {
  return request({
    url: '/api/console/developers',
    method: 'get'
  });
}

// 获取首页统计信息
export function getDashboardStatistics(data) {
  return request({
    url: '/api/console/statistics',
    method: 'get',
    params: data
  });
}

// 上传图片
export function uploadImg(data) {
  return request({
    url: '/api/console/image',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: data
  });
}

// 开始压缩
export function startCompress(data) {
  return request({
    url: '/api/console/image/compress',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: data,
  });
}

// 获取压缩图片
export function getCompressPic(fileId) {
  return request({
    url: `/api/console/image/${fileId}`,
    method: 'get',
  });
}

// 获取压缩结果
export function getCompressResult(fileId) {
  return request({
    url: `/api/console/image/result/${fileId}`,
    method: 'get',
  });
}

// 提交反馈
export function postFeedback(fileId,data) {
  return request({
    url: `/api/console/image/feedback/${fileId}`,
    method: 'put',
    data: data
  });
}

// 获取文档列表
export async function getDocsList() {
  try {
    const res = await axios.get(`${config.baseUrl}/api/console/docs?Authorization=1`);
    const docsData = res.data && res.data.data;
    return docsData;
  } catch (error) {
    console.log(error);
  }
}

